import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import { Form, Formik } from "formik";
import React from "react";
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import MDButton from "../../../components/MDButton";
import MDSnackbar from "../../../components/MDSnackbar";
import BaseLayout from "../../../components/BaseLayout";
import useNewProduct from "./useNewProduct"; // Make sure create a similar hook for products
import NewProductForm from "./components/NewProductForm/NewProductForm"; // Make sure create a NewProductForm

const NewProduct = () => {
    const { show, validations, initialValues, formId, formField, isLoading, snackbarConfig, handleSubmit, toggleSnackbar } = useNewProduct();

    return (
        <BaseLayout>
            <Grid container justifyContent="center">
                <Grid item xs={12} lg={8}>
                    <MDBox mb={3}>
                        <Card id="new-product" sx={{ overflow: "visible" }}>
                            {
                                isLoading ?
                                    <MDBox mt={2} mx={2} p={10} display="flex" justifyContent="center" alignItems="center">
                                        <CircularProgress color="secondary" style={{ overflow: 'hidden' }} />
                                    </MDBox> :
                                    <Formik
                                        initialValues={initialValues}
                                        validationSchema={validations}
                                        onSubmit={handleSubmit}
                                    >
                                        {({ values, errors, touched, isSubmitting }) => (
                                            <Form id={formId} autoComplete="off">
                                                <MDBox p={3}>
                                                    <MDTypography variant="h5">Nuevo Producto</MDTypography>
                                                    <MDTypography variant="body2">Ingresa los detalles del producto.</MDTypography>
                                                </MDBox>
                                                <MDBox pb={3} px={3}>
                                                    <NewProductForm formData={{ values, touched, formField, errors }} />
                                                    <MDBox mt={2} width="100%" display="flex" justifyContent="flex-end">
                                                        <MDBox>
                                                            <MDButton
                                                                disabled={isSubmitting}
                                                                variant="gradient"
                                                                color="secondary"
                                                                type="submit"
                                                            >
                                                                {isSubmitting &&
                                                                    <CircularProgress size={18} color="white" sx={{ marginRight: 1 }} />}
                                                                Crear
                                                            </MDButton>
                                                        </MDBox>
                                                    </MDBox>
                                                </MDBox>
                                            </Form>
                                        )}
                                    </Formik>
                            }
                        </Card>
                    </MDBox>
                </Grid>
            </Grid>
            <MDSnackbar
                color={snackbarConfig.color}
                icon={snackbarConfig.icon}
                title={snackbarConfig.title}
                content={snackbarConfig.message}
                dateTime=""
                autoHideDuration={3000}
                open={show}
                close={toggleSnackbar}
            />
        </BaseLayout>
    );
};

export default NewProduct;
